export const EXPENSE_CATEGORY = {
  MATERIAL_EQUIPMENT: 'MATERIAL_EQUIPMENT',
  TRANSPORT: 'TRANSPORT',
  MARKETING: 'MARKETING',
  TAXES: 'TAXES',
  OTHER: 'OTHER',
} as const;

export type ExpenseCategory = (typeof EXPENSE_CATEGORY)[keyof typeof EXPENSE_CATEGORY];

export interface Expense {
  id: string;
  providerId: string;
  amount: number;
  date: string;
  category?: ExpenseCategory;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export const EXPENSE_CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  [EXPENSE_CATEGORY.MATERIAL_EQUIPMENT]: 'Material/Equipamento',
  [EXPENSE_CATEGORY.TRANSPORT]: 'Transporte',
  [EXPENSE_CATEGORY.MARKETING]: 'Marketing',
  [EXPENSE_CATEGORY.TAXES]: 'Impostos/Taxas',
  [EXPENSE_CATEGORY.OTHER]: 'Outros',
};
